import React, { Component } from 'react';


class AboutPage extends Component {

    render() {
        return (
            <div className="about-page">

                <a href="https://en.wikipedia.org/wiki/Rapid_serial_visual_presentation">RSVP reading</a>
            </div>
        );
    }
}

export default AboutPage;







// WEBPACK FOOTER //
// ./src/Components/AboutPage.jsx